module.exports = "<div class=\"gw-banner\">\r\n\t<div class=\"container row\">\r\n\t\t<div class=\"img-left col-5 left\">\r\n\t\t\t<img src=\"../../assets/img/banner-pic.png\" alt=\"banner\">\r\n\t\t</div>\r\n\t\t<div class=\"summay-right col-5 right\">\r\n\t\t\t<h1>{{banner_title1}}</h1>\r\n\t\t\t<h2>{{banner_title2}}</h2>\r\n\t\t\t<h3>{{banner_summay}}</h3>\r\n\t\t</div>\r\n\t</div>\r\n</div>"


//////////////////
// WEBPACK FOOTER
// C:/Users/Administrator/submit text project/gwin/src/app/comment/banner/banner.component.html
// module id = ../../../../../src/app/comment/banner/banner.component.html
// module chunks = 3